const { documentReady, checkRecaptcha } = require('./helpers');

function heroVideo() {
  let videoWrappers = document.querySelectorAll('.heroVideo');

  videoWrappers.forEach((wrapper) => {
    let video = wrapper.querySelector('video');
    let button = wrapper.querySelector('button');
    let cover = wrapper.querySelector('.video__cover');

    if (button) {
      button.addEventListener('click', function () {
        checkRecaptcha().then((isValidated) => {
          if (isValidated) {
            cover.addEventListener('transitionend', function () {
              cover.classList.add('hidden');
            });
            cover.classList.add('hiding');
            wrapper.classList.remove('paused');

            video.play();
          }
        });
      });
    }
  });
}

documentReady(heroVideo);
